<app-menu>
  <div class="desktop">
    <app-voltar class="back" />
    <div class="header">
      <app-titulo
        [text]="isEditing ? 'Editar fornecedor' : 'Cadastrar fornecedor'"
      ></app-titulo>
    </div>
    <form class="form">
      <app-input
        type="text"
        width="100%"
        label="Nome do fornecedor"
        name="NmFornecedor"
        [requiredInput]="true"
        [(ngModel)]="form.NmFornecedor"
      ></app-input>
      <app-input
        type="text"
        width="100%"
        label="E-mail"
        name="TxEmailFornecedor"
        [(ngModel)]="form.TxEmailFornecedor"
      ></app-input>
      <app-input
        type="text"
        width="100%"
        label="Telefone / Celular"
        name="TxTelefoneFornecedor"
        mask="(00) 0000-0000||(00) 00000-0000"
        [requiredInput]="true"
        [(ngModel)]="form.TxTelefoneFornecedor"
      ></app-input>
      <app-input
        type="text"
        width="100%"
        label="Endereço"
        name="TxEnderecoFornecedor"
        [requiredInput]="true"
        [(ngModel)]="form.TxEnderecoFornecedor"
      ></app-input>
      <app-select-adicao
        *ngIf="!isEditing"
        label="Material fornecido"
        [requiredInput]="true"
        [selectData]="materiaisOptions"
        (items)="updateMateriais($event)"
      ></app-select-adicao>
      <div *ngIf="form.Materiais.length">
        <label>Preço do material (Kg)</label>
        <ul class="materials">
          <li class="materials-div" *ngFor="let material of form.Materiais">
            <span>
              {{ material.NmMaterial }}
            </span>
            <app-input
              type="money"
              name="VlMaterial_{{ material.MaterialId }}"
              [(ngModel)]="material.VlMaterial"
              [disabled]="isEditing"
            ></app-input>
          </li>
        </ul>
      </div>
      <app-input
        type="money"
        width="100%"
        label="Preço do frete"
        name="precoFrete"
        [requiredInput]="true"
        [disabled]="isEditing"
        [(ngModel)]="form.VlPrecoFreteFornecedor"
      ></app-input>
      <app-input
        type="number"
        width="100%"
        label="Previsão de entrega"
        name="previsaoEntrega"
        [requiredInput]="true"
        [(ngModel)]="form.QtDiaPrevisto"
      ></app-input>
      <app-input
        type="textarea"
        width="100%"
        label="Observações"
        name="TxObservacaoFornecedor"
        [(ngModel)]="form.TxObservacaoFornecedor"
      ></app-input>
    </form>
    <div class="form-button">
      <app-botao
        width="100%"
        [text]="isEditing ? 'Editar' : 'Cadastrar'"
        (click)="postForm()"
        [disabled]="validarForm()"
      ></app-botao>
    </div>
  </div>
</app-menu>

<app-loader *ngIf="loader" />
